/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

export const LOAD_LIST_SUBSCRIBERS_MAX_COSTS_REQUEST =
    '@@b2b_portal_ui/widgetSubscriberMaxCosts/LOAD_LIST_SUBSCRIBERS_MAX_COSTS_REQUEST';

export const LOAD_LIST_SUBSCRIBERS_MAX_COSTS_SUCCESS =
    '@@b2b_portal_ui/widgetSubscriberMaxCosts/LOAD_LIST_SUBSCRIBERS_MAX_COSTS_SUCCESS';

export const LOAD_LIST_SUBSCRIBERS_MAX_COSTS_FAIL =
    '@@b2b_portal_ui/widgetSubscriberMaxCosts/LOAD_LIST_SUBSCRIBERS_MAX_COSTS_FAIL';

export const CLEAN_LIST_SUBSCRIBERS =
    '@@b2b_portal_ui/widgetSubscriberMaxCosts/CLEAN_LIST_SUBSCRIBERS';
